// probably timing problem with lit: https://github.com/lit/lit/blob/7453e365000e6a289c139cf7e175a4742296333d/packages/reactive-element/src/css-tag.ts#L10
// if lit is loaded before style sheet it cannot handle CSSStyleSheets from AdornisCSS
import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY

import { A } from '@adornis/base/env-info.js';
import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { registerMatchingMails } from '@adornis/bh-matching-mails/mail-registry.js';
import '@adornis/bh-matching-translation/translations.js';
import {
  activateAllUsedPlugins,
  registerAllBuchungsheldPlugins,
} from '@adornis/bh-plugin-impl/register-all-plugins.js';
import { initBuchungsheldAuthentication } from '@adornis/buchungsheld-db/authentication/buchungsheld-authentication.js';
import { User } from '@adornis/buchungsheld-db/entities/user.js';
import '@adornis/buchungsheld-theme/index.js';
import '@adornis/chemistry/elements/components/x-icon.css';
import { disableAutomaticScrollTop } from '@adornis/chemistry/viewport.js';
import { XNativeDialog } from '@adornis/dialog/x-native-dialog.js';
import '@adornis/fonts/fonts.js';
import '@adornis/fonts/fontSrc/lato.js';
import '@adornis/fonts/fontSrc/maven-pro.js';
import { provideGlobalContext } from '@adornis/functional-lit/directive-provide-context.js';
import { initApp } from '@adornis/functional-lit/init-app.js';
import { translationContext } from '@adornis/internationalization/client/translation-context.js';
import '@adornis/popover/x-dropdown.css';
import { subscribeTranslationDictionaryAndUpdateClientTranslator } from '@adornis/translation/db/translation-entry.js';
import { subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { html } from 'lit';
import '../api/index.js';
import { m } from '../../localization/out/messages.js';
import { TestDataDialog } from './components/test-data-dialog.js';
import albertSansBold from './fonts/AlbertSans-Bold.ttf';
import albertSansLight from './fonts/AlbertSans-Light.ttf';
import albertSansRegular from './fonts/AlbertSans-Regular.ttf';
import albertSansThin from './fonts/AlbertSans-Thin.ttf';
import './main-element.js';
import './tailwind.css' with { type: 'tailwind' };

// we need this because somehow this gets imported from somewhere in the project but shouldn't be
// can be removed as soon as chemistry isn't used anymore
disableAutomaticScrollTop();

BaseQLClient.initDefault();

void subscribeCurrentUser(() => selectionSet(() => User, 3, ['participations']));

subscribeTranslationDictionaryAndUpdateClientTranslator().subscribe();

registerAllBuchungsheldPlugins();
void activateAllUsedPlugins();
registerMatchingMails();

provideGlobalContext(translationContext, m);

void initBuchungsheldAuthentication().then(() => initApp(() => html` <main-element></main-element> `));

// Add event listener for Ctrl+D to open test data dialog
document.addEventListener('keydown', event => {
  // Check if Ctrl+D was pressed (keyCode 68 is 'D')
  if (event.ctrlKey && event.keyCode === 68) {
    // Prevent the default browser behavior (bookmark dialog)
    event.preventDefault();

    XNativeDialog.showPopup({
      content: html`<x-card>${TestDataDialog({ onClose: () => {} })}</x-card>`,
    });
  }
});

// fonts
// TODO: can I share the fonts from bh-theme between entrypoints?
const style = document.createElement('style');
style.innerHTML = `
@font-face {
  font-family: "Albert Sans";
  src: url('${A.absoluteUrl(albertSansRegular)}');
  font-weight: normal;
}
@font-face {
  font-family: "Albert Sans";
  src: url('${A.absoluteUrl(albertSansLight)}');
  font-weight: light;
}
@font-face {
  font-family: "Albert Sans";
  src: url('${A.absoluteUrl(albertSansThin)}');
  font-weight: 100;
}
@font-face {
  font-family: "Albert Sans";
  src: url('${A.absoluteUrl(albertSansBold)}');
  font-weight: bold;
}
`;

document.head.appendChild(style);
